export var ChannelAction = /*#__PURE__*/ function(ChannelAction) {
    ChannelAction[ChannelAction["ChannelJoin"] = 1] = "ChannelJoin";
    ChannelAction[ChannelAction["ChannelJoinRoomOrGame"] = 2] = "ChannelJoinRoomOrGame";
    return ChannelAction;
}({});
export const PRIMARY_CHANNEL_ACTIONS = [
    1,
    2
];
